{
  "Earlier": "ANTERIORMENTE",
  "noAnnouncements": "Você receberá informações sobre atividades de manutenção agendadas e problemas do produto que estão sendo corrigidos",
  "noAnnouncementsTitle": "Seus anúncios aparecerão aqui"
}
